module.exports = __webpack_public_path__ + "img/white-car.0d1e2585.jpg";